import { useState, useEffect } from "react";
import { IoTimer } from "react-icons/io5";
import { FaTruckMoving, FaTruck, FaMapMarkerAlt } from "react-icons/fa";
import { BsBagCheckFill } from "react-icons/bs";
import EachProductBought from "./EachProductBought";
import { updateOrderStatusUrl, updateOrderStatusToQuerryUrl } from "../../api/endpoints";
import { useSelector } from "react-redux";

const DetailOfReceivedOrder = ({ fetchRecievedOrders, setSelectedOrder, selectedOrder, socket, userCurrency }) => {
  const [timer, setTimer] = useState(0);
  const [deliveryStatus, setDeliveryStatus] = useState("pending");
  const [reloadDeliveryGauge, setReloadDeliveryGauge] = useState(false);
  const [hasOrderBeenMarkedAsQuery, setHasOrderBeenMarkedAsQuery] = useState(false);

  const { store } = useSelector((state) => state.store);

  useEffect(() => {
    setDeliveryStatus(selectedOrder.orderDetails.orderStatus);

    let DeliveryDate = new Date(selectedOrder.expectedDeliveryDate).getTime();
    let x = setInterval(() => {
      let now = new Date().getTime();
      let distance = DeliveryDate - now;
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
      //  setTimer(days + "d " + hours + "h " + minutes + "m " + seconds + "s ");

      let timer = days + "days " + hours + "hr " + minutes + "min " + seconds + "s ";

      /* check if distance is less than zero meaning delivery window has passed  */

      if (distance < 0) {
        clearInterval(x);

        /* place order on query. in the future, if days is more than -3 order would be canceled */
        selectedOrder.orderDetails.orderStatus !== "query" &&
          selectedOrder.orderDetails.orderStatus !== "dispute" &&
          selectedOrder.orderDetails.orderStatus !== "delivered" &&
          selectedOrder.orderDetails.orderStatus !== "cancelled" &&
          /* hasOrderBeenMarkedAsQuery === false && */
          updateOrderStatusWithOutStateUpdate("query", fetchRecievedOrders); /* updates only for shipped and pending orders */
      } else {
        if (selectedOrder.orderDetails.orderStatus !== "query") {
          setTimer(timer);
        } else {
          clearInterval(x);
        }
      }
    }, 1000);

    if (selectedOrder.orderDetails.orderStatus === "delivered") {
      clearInterval(x);
    }
    return () => {
      clearInterval(x);
    };
  }, [selectedOrder, reloadDeliveryGauge]);

  useEffect(() => {
    let circle = document.querySelector("#receivedOrderCircle");

    let icons = document.querySelector(".InnerCirlegauge>svg");
    if (deliveryStatus === "pending") {
      circle.style.strokeDashoffset = "400";
      console.log("pending");
    }
    if (deliveryStatus === "shipped") {
      circle.style.strokeDashoffset = "180";
    }
    if (deliveryStatus === "delivered") {
      circle.style.strokeDashoffset = "0";
    }
  }, [deliveryStatus]);

  const updateOrderStatus = async (status) => {
    try {
      let response = await fetch(updateOrderStatusUrl + selectedOrder._id, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify({ orderStatus: status }),
      });

      if (response.ok) {
        let updatedOrder = await response.json();
        fetchRecievedOrders();
        setSelectedOrder(updatedOrder);
        setReloadDeliveryGauge(reloadDeliveryGauge);
        console.log("emitting");
        socket.emit("updateOrderStatus", { room: selectedOrder.customer._id, message: `Your order from ${store.storeName} has been ${status}`, updatedOrder });
      }
    } catch (error) {
      console.log(error);
    }
  }; /* for all products in the the order */
  const updateOrderStatusWithOutStateUpdate = async (status) => {
    console.log("hasOrderBeenMarkedAsQuery", hasOrderBeenMarkedAsQuery);

    try {
      let response = await fetch(updateOrderStatusToQuerryUrl + selectedOrder._id, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify({ orderStatus: status }),
      });

      if (response.ok) {
        let updatedOrder = await response.json();
        setSelectedOrder(updatedOrder);
        /* setReloadDeliveryGauge(reloadDeliveryGauge);  */
        fetchRecievedOrders();
        console.log("emitting");
        socket.emit("updateOrderStatus", {
          room: selectedOrder.customer._id,
          message: `Your order from ${store.storeName} has been placed on ${status}`,
          updatedOrder,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }; /* for all products in the the order */

  return (
    <>
      <div className='receivedOrderDetails'>
        <div className='orderInfoAndCustomerinfo'>
          <div className='customerInfoReceivO'>
            <span>{selectedOrder?.customer.fullName}</span>
            <p>{selectedOrder?.customer.email}</p>
            <p>{selectedOrder?.customer.phoneNumber}</p>
          </div>

          <div className='ReceivedOrderProdInfoDIv'>
            <div>
              <p>Total paid</p>
              <p>
                {userCurrency} {selectedOrder?.orderDetails.totalPricePaid}
              </p>
            </div>
          </div>
        </div>
        <div className='shippingAddressDIv11'>
          <div>
            <div className='shippingIconDiv'>
              <FaTruck size={30} color='rgba(55,104,193,1)' />
            </div>
            <div>
              <p className='shippingAddressTitlt5'>Shipping address</p>
              <p>{selectedOrder?.orderDetails?.deliveryAddress}</p>
            </div>
          </div>
          <div>
            {" "}
            <FaMapMarkerAlt color='3768C1' />{" "}
          </div>
        </div>

        <div className='productListConatiner2'>
          {selectedOrder.products.map((product) => (
            <EachProductBought
              key={product._id}
              product={product}
              orderID={selectedOrder._id}
              setSelectedOrder={setSelectedOrder}
              fetchRecievedOrders={fetchRecievedOrders}
              setReloadDeliveryGauge={setReloadDeliveryGauge}
              socket={socket}
              selectedOrder={selectedOrder}
              store={store}
              userCurrency={userCurrency}
            />
          ))}
        </div>
      </div>

      {/* trancking */}

      {/* trancking */}
      <DeliveryGaugeCom
        deliveryStatus={deliveryStatus}
        timer={timer}
        selectedOrder={selectedOrder}
        updateOrderStatus={updateOrderStatus}
        fetchRecievedOrders={fetchRecievedOrders}
      />
    </>
  );
};

export default DetailOfReceivedOrder;

const DeliveryGaugeCom = ({ deliveryStatus, timer, selectedOrder, updateOrderStatus }) => {
  return (
    <>
      {/* trancking */}
      <div className='receivedOrtranc'>
        <div className='guageTrackDiv'>
          <div className='gaugeTrack'>
            <div className='InnerCirlegauge'>
              {deliveryStatus === "pending" && <IoTimer color='#b50e0e' />}
              {deliveryStatus === "shipped" && <FaTruckMoving color='rgba(55,104,193,1)' />}
              {deliveryStatus === "delivered" && <BsBagCheckFill color='#00B87C' />}
            </div>
          </div>

          <svg height='200' width='200'>
            <defs>
              {deliveryStatus === "pending" && (
                <linearGradient id='guageLinrGrad'>
                  {/*  <stop offset="0%" stopColor="rgb(167, 193, 240)" />
                <stop offset="100%" stopColor="rgba(55,104,193,1)" /> */}
                  <stop offset='0%' stopColor='#ee9090' />
                  <stop offset='100%' stopColor='#b50e0e' />
                </linearGradient>
              )}
              {deliveryStatus === "shipped" && (
                <linearGradient id='guageLinrGrad'>
                  <stop offset='0%' stopColor='rgb(167, 193, 240)' />
                  <stop offset='100%' stopColor='rgba(55,104,193,1)' />
                </linearGradient>
              )}
              {deliveryStatus === "delivered" && (
                <linearGradient id='guageLinrGrad'>
                  <stop offset='0%' stopColor='#98e9ce' />
                  <stop offset='100%' stopColor='#00B87C' />
                </linearGradient>
              )}
            </defs>
            <circle id='receivedOrderCircle' cx='100' cy='100' r='90' stroke='black' strokeLinecap='round' />
          </svg>
        </div>
        {/* <button onClick={animate}>animate</button> */}

        <div className='UpdateDeliverySta'>
          <button
            onClick={() => {
              // setDeliveryStatus("shipped");
              deliveryStatus !== "dispute" && updateOrderStatus("shipped");
            }}
            className={deliveryStatus === "pending" ? "updateStatusBUtton updateStatusBuutonActive" : "updateStatusBUtton"}
          >
            Shipped all
          </button>
          <button
            onClick={() => {
              //setDeliveryStatus("delivered");
              deliveryStatus !== "dispute" && updateOrderStatus("delivered");
            }}
            className={deliveryStatus === "shipped" ? "updateStatusBUtton updateStatusBuutonActive" : "updateStatusBUtton"}
          >
            Delivered all
          </button>
        </div>
        <div className='updateDelStattext'>
          {deliveryStatus === "pending" && <p>Please update delivery status</p>}
          {deliveryStatus === "shipped" && <p>Mark delivered when all items are handed over to customer</p>}
          {deliveryStatus === "delivered" && (
            <p style={{ color: "#00B87C" }}> {selectedOrder.products.length > 1 ? "items are delivered" : "Item is delivered "} </p>
          )}
          {deliveryStatus === "dispute" && <p style={{ color: "#00B87C" }}>Order is on dispute see instructions</p>}
          {deliveryStatus === "query" && <p style={{ color: "#00B87C" }}>Order is placed on query by admin</p>}
        </div>
        {deliveryStatus !== "delivered" &&
          (deliveryStatus === "dispute" ? (
            <div className='disputeInstruction22'>
              <p>Note: Since customer has marked this item on dispute, payout for this item is delayed until dispute is resolved</p>
              <button>See instructions to resolve dispute</button>
            </div>
          ) : deliveryStatus === "query" ? (
            <div className='disputeInstruction22'>
              <p>Seem you didnt deliver one or more items within 4 days. All orders must be marked as delivered within 4 day. Did you deliver all item?</p>
              <button>See instructions and act now!</button>
            </div>
          ) : (
            <div className='timeToDeliverDIV11'>
              <div className='countDownClockDiv33'>
                <p>{timer}</p>
              </div>
              <p>Counting down to delivery of all items</p>
            </div>
          ))}
      </div>
    </>
  );
};
